/**
 * UX-3 — the PROVISIONAL-BOOK notice. When the current month has no conversion pool set (the book is
 * `pool_unset`, or otherwise not-set-up), every cost/margin the quote and price screens show is
 * MATERIAL-ONLY — a provisional number acted on before the book is complete. This surfaces that fact
 * CALMLY and read-only, exactly where a provisional number is being acted on.
 *
 * ONE SIGNAL, not a new one: the caller passes `show` derived from `params.health.healthy` on
 * GET /api/assumptions/month — the SAME authority the dashboard's `costBasis` reads
 * (services/commandCenter.ts costBasisHealth → getAbsorptionParams(...).health). This component never
 * fetches; each screen reads its own health and passes the boolean, so there is one banner definition
 * and no second copy of the signal.
 *
 * FAILS SILENT: the caller only sets `show` true when health is explicitly not-healthy. A missing/absent
 * health field never renders the banner — absence of the banner never asserts "the book is complete".
 *
 * Deliberately CALM (amber, not the loud red STAGING marker): the owner resolved this to be read-only,
 * no action button. It keeps the fix-HINT the loud E16-03 warning it supersedes carried — name the one
 * thing to set («فرض ماهانه» in تنظیمات) — as plain text, so a quoting operator loses no guidance, only noise.
 */
export function ProvisionalBookBanner({ show }: { show: boolean }): React.JSX.Element | null {
  if (!show) return null;
  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        position: 'sticky',
        top: 0,
        zIndex: 20,
        background: 'var(--warn-bg, #fef3c7)',
        color: 'var(--warn-fg, #92400e)',
        border: '1px solid var(--warn-border, #fcd34d)',
        borderRadius: 8,
        textAlign: 'center',
        padding: '7px 12px',
        marginBottom: 12,
        fontSize: 13,
        fontWeight: 500,
      }}
    >
      کتاب هنوز کامل تنظیم نشده — این عدد موقت است؛ «فرض ماهانه» را در تنظیمات تعیین کنید.
    </div>
  );
}
